// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1DkmA","requiredAsterisk":"Info_requiredAsterisk__2aqqI"};